import FractionDigits from '@/Enums/Localization/FractionDigits.enum';
import ReportProperty from '@/Enums/Report/BeeswaxReportProperties.enum';
import type { IFootTrafficImpressionsReportsTotal } from '@/Interfaces/Attribution/FootTraffic.interface';

const normalizeInputNumber = (input: any, fallbackValue: number = 0): number => {
  const assumedNumber = +input;
  if (Number.isFinite(assumedNumber)) {
    return assumedNumber;
  }
  return fallbackValue;
};

export const numberToPercent = (value: number, options?: Intl.NumberFormatOptions): string => {
  const normalizedInput = normalizeInputNumber(value);
  const maximumFractionDigits = options?.maximumFractionDigits ?? FractionDigits.Default;
  // Default minimum to match the maximum so values render with consistent
  // precision — "93.0%" instead of "93%". Demo feedback from Matt asked
  // for predictable 1-decimal display across percent metrics.
  const minimumFractionDigits = options?.minimumFractionDigits ?? maximumFractionDigits;

  return normalizedInput.toLocaleString('en-US', {
    ...options,
    style: 'percent',
    maximumFractionDigits,
    minimumFractionDigits,
  });
};

export const numberToUsFormat = (value: number, options?: Intl.NumberFormatOptions) => {
  const normalizedInput = normalizeInputNumber(value);
  const maximumFractionDigits = options?.maximumFractionDigits ?? FractionDigits.Default;

  return normalizedInput.toLocaleString('en-US', { ...options, maximumFractionDigits });
};

export const numberToUsd = (value: number, options?: Intl.NumberFormatOptions) => {
  const normalizedInput = normalizeInputNumber(value);
  const minimumFractionDigits = options?.minimumFractionDigits ?? FractionDigits.Extended;
  const maximumFractionDigits = options?.maximumFractionDigits ?? FractionDigits.Extended;

  return normalizedInput.toLocaleString('en-US', {
    ...options,
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
    minimumFractionDigits,
  });
};

export const liftPercentToDisplay = (
  liftPercent: IFootTrafficImpressionsReportsTotal[ReportProperty.LIFT_PERCENT],
  showLiftPercent: boolean,
): string => {
  if (!showLiftPercent) {
    return '-';
  }

  if (!Number.isFinite(liftPercent)) {
    return 'N/A';
  }

  return numberToPercent(liftPercent!);
};
